module.exports = __webpack_public_path__ + "europa-5-hologram.jpg?5471fd9ba9c4cc0d364b6c0f0a425ca2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5-hologram.jpg
// module id = 347
// module chunks = 0